import { useTranslation } from 'react-i18next';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';
import { Button, Grid2, Typography } from '@mui/material';
import { Add, FolderOutlined, RequestQuote } from '@mui/icons-material';

const PriceGroupEmptyState = ({ isPriceGroupTab = false, handleWizard = () => {} }) => {
    const { t: translate } = useTranslation();
    const { handleOpenForm } = usePriceGroupTab();

    const handleOpen = () => {
        if (isPriceGroupTab) {
            handleOpenForm();
            return;
        }

        handleWizard();
    };

    return (
        <Grid2 container mt="32px" flexDirection="column" justifyContent="center" alignItems="center" gap="12px">
            {isPriceGroupTab ? <FolderOutlined sx={{ fontSize: 72, color: 'var(--color-utriper-blue)' }} /> : <RequestQuote sx={{ fontSize: 72, color: 'var(--color-utriper-blue)' }} />}
            <Grid2 container flexDirection="column" justifyContent="center" alignItems="center" gap="8px">
                <Typography fontSize={20} fontWeight={700} textAlign="center" sx={{ color: '#131313' }}>
                    {isPriceGroupTab ? translate('price_group_tab.empty_state.title') : translate('price_group_tab_id.empty_state.title')}
                </Typography>
                <Typography fontSize={16} fontWeight={500} textAlign="center" sx={{ color: '#131313bf' }}>
                    {isPriceGroupTab ? translate('price_group_tab.empty_state.description') : translate('price_group_tab_id.empty_state.description')}
                </Typography>
            </Grid2>
            <Button sx={{ backgroundColor: 'var(--color-utriper-blue)', padding: '14px', minWidth: '48px' }} variant="contained" startIcon={<Add sx={{ color: '#fff', fontSize: '24px' }} />} onClick={handleOpen}>
                {isPriceGroupTab ? translate('price_group_tab.empty_state.button') : translate('price_group_tab_id.empty_state.button')}
            </Button>
        </Grid2>
    );
};

export default PriceGroupEmptyState;
